@if (!loaded) {
  <nz-spin nzSimple></nz-spin>
}

@if (loaded) {
  <nz-select
    nzShowSearch
    nzAllowClear
    style="width: 100%"
    nzPlaceHolder="Select a Company"
    nzServerSearch
    [nzFilterOption]="nzFilterOption"
    (nzOnSearch)="search($event)"
    [(ngModel)]="selectedCompany"
  >
    @for (item of foundCompanies | sortBy: 'administrator'; track item) {
      <nz-option [nzLabel]="item.administrator" [nzValue]="item"></nz-option>
    }
  </nz-select>
}

@if (selectedCompany) {
  <div>
    <nz-divider></nz-divider>
    <strong>Details of chosen company</strong>
    <div>
      <div>Company Name: {{ selectedCompany.company }}</div>
      <div>Title: {{ selectedCompany.title }}</div>
      <div>Administrator: {{ selectedCompany.administrator }}</div>
      <div>Email: {{ selectedCompany.email }}</div>
      <div>Phone: {{ selectedCompany.phone }}</div>
    </div>
  </div>
}

<div *nzModalFooter>
  @if (login) {
    <button nz-button nzType="default" nzDanger (click)="logout()">Logout</button>
  }
  <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
  <button nz-button nzType="primary" (click)="select()">Login</button>
</div>
